import * as sonbp from "sonbp";
import * as ifbase from "../../base";
import { itemMani } from "../../tool";
import { poscaMoveEditor } from "./poscaMoveEditor";
import { poscaVitem } from "./poscaVitem";

/**
* ポスカ用コンテンツエディター
* @summary ハンドル操作をピックアップで処理するように拡張しています。
*/
export abstract class poscaPickupEditor extends poscaMoveEditor {

	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super(ifdto);
		this._preventSelectorDrawing = true;
	}

	// -----------------------------------------------
	// Properties（内部変数）
	// -----------------------------------------------

	/**
	 * 操作対象情報クラス
	 */
	protected _vitem: poscaVitem;

	/**
	 * 直前の拡縮値
	 */
	protected _preScaleValue: { sx: number, sy: number, mx: number, my: number };

	// -----------------------------------------------
	// Accessors（外部アクセス用プロパティ）
	// -----------------------------------------------

	// -----------------------------------------------
	// Methods（外部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * リスナーセット初期処理
	 * @override
	 */
	public init(): void {
		super.init();

		this._preventSelectorDrawing = true;

		this._preScaleValue = null;
	}

	/**
	 * 処理取得
	 * @override
	 */
	public take(select: sonbp.type.select): boolean {
		return super.take(select);
	}

	/**
	 * @override
	 * @summary カレントエディタが別のものに置き換わった時にカレントエディタに対して呼び出されます。
	 * */
	public leave(): void {
		this.init();
		this._vitem = null;
		this._v._lm.unsetPickUpper(this);
	}

	// -----------------------
	// イベント受付機能 関数
	// -----------------------

	/**
	 * ムーブ内部処理
	 * @override
	 */
	protected onMove(vp: sonbp.type.localViewPosition, hasShiftKey: boolean): sonbp.type.listerResult {

		this._preScaleValue = null;

		if (!this._select.isSamePageIndex) return new sonbp.type.listerResult();
		if (!this._state || !this._state.handle) return new sonbp.type.listerResult();

		// 編集中の処理

		this._state.ept = vp;
		let idx = this._v._dm.pageIdxs.indexOf(this._state.mvs.apply_pageIdx);
		let spt = this._state.spt.docPt[idx];
		let ept = this._state.ept.docPt[idx];

		if (this._state.type == 999) {

			// 先送りしたハンドルをセット

			let handle = this.getEditHandle(vp);

			if (handle) {
				this.editStateChange(true);
				this._state.start(handle, vp, this.getMovers());
			} else {
				this.init();
				this.editStateChange(false);
			}

			return new sonbp.type.listerResult();
		}

		if (this._state.prepare && this._state.type == 6 && this.actionModeForMTouch == 2) {
			// ２点タッチのリサイズ＆回転モードで、最初のアクションでどちらかの制御に決定するモードの場合
			// →ここでモードをきめてやる

			const skip = (): sonbp.type.listerResult => {
				let result = new sonbp.type.listerResult();
				result.isPrevent = true;
				result.isDrawEditCanvas = true;
				return result;
			}

			let spts = this._state.spt.touchLocalVps.length > 1 ? this._state.spt.touchLocalVps : this._state.spt.changedTouchLocalVps;
			let epts = this._state.ept.touchLocalVps.length > 1 ? this._state.ept.touchLocalVps : this._state.ept.changedTouchLocalVps;

			let rad0 = sonbp.util.c2d.deg(sonbp.util.c2d.getRadian(spts[0].docPt[idx], spts[1].docPt[idx]));
			let rad1 = sonbp.util.c2d.deg(sonbp.util.c2d.getRadian(epts[0].docPt[idx], epts[1].docPt[idx]));
			let r = Math.abs(rad1 - rad0);
			const sr = 3;

			let len0 = sonbp.util.c2d.getDistance(spts[0].docPt[idx], spts[1].docPt[idx]);
			let len1 = sonbp.util.c2d.getDistance(epts[0].docPt[idx], epts[1].docPt[idx]);
			let s = Math.abs(1 - len1 / len0);
			const ss = 0.03;

			// どちらかの閾値を先に超えた場合にモードを決定する

			//(util.js.gE("console_box") as HTMLDivElement).innerText = "r: " + r.toString()+" s: "+s.toString();

			if (sr > r && ss > s) return skip();

			if (sr < r && ss < s) {
				// 両方閾値を超えている場合は超えた割合が大きい方を採用
				if (s / ss > r / sr) this._state.handle.type = 4;
				else this._state.handle.type = 5;
			}
			else if (ss < s) {
				// スケールだけ閾値越え
				this._state.handle.type = 4;
			}
			else if (sr < r) {
				// 回転だけ閾値越え
				this._state.handle.type = 5;
			}
		}

		this._state.prepare = false;
		let docPt = vp.docPt[this._v._dm.pageIdxs.indexOf(this._select.pageIndex)];

		// 操作処理

		let pmatrix = this._select.items[0]._apply_pmatrix;

		if (spt.equals(ept)) {
		}
		else if (this._state.type == 1) {
			let omatrix = sonbp.util.c2d.matrixInverse(pmatrix);
			omatrix[4] = omatrix[5] = 0;
			let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(docPt.x - spt.x, docPt.y - spt.y), omatrix);

			this._vitem.save();
			this._vitem.init();
			this._vitem.move(v.x, v.y);
		}
		else if (this._state.type == 2) {
			let omatrix = sonbp.util.c2d.matrixInverse(pmatrix);
			omatrix[4] = omatrix[5] = 0;

			let x = docPt.x - spt.x;
			let y = docPt.y - spt.y;
			x *= 2;
			y *= 2;
			let v = sonbp.util.c2d.setPointMatrix(new sonbp.type.point(x, y), omatrix);

			this._vitem.save();
			this._vitem.init();
			var pts = this._vitem.getPoints();
			let ptIdx = this._state.ptIdx;
			var sc = this.scaleSub(v, pts, ptIdx);

			this._vitem.scale(sc[0], sc[1]);

			ptIdx = 4;		//左右に広がるので中央固定

			var oppsitIdx = 8 - ptIdx;
			var pts2 = this._vitem.getPoints();
			let mx = pts[oppsitIdx].x - pts2[oppsitIdx].x;
			let my = pts[oppsitIdx].y - pts2[oppsitIdx].y;
			this._vitem.move(mx, my);

			this._preScaleValue = { sx: sc[0], sy: sc[1], mx: mx, my: my };
		}
		else if (this._state.type == 3) {
			var points = sonbp.util.c2d.setPointsMatrix(this._vitem.getPoints(), pmatrix);
			let rad = this.rotateSub(spt, docPt, points, 0);

			this._vitem.save();
			this._vitem.init();
			this._vitem.rotate(rad);
		}
		else if (this._state.type == 4 || this._state.type == 5 || this._state.type == 6) {

			// --------------------
			// ２点 リサイズ／回転／リサイズ＆回転
			// --------------------

			let spts = this._state.spt.touchLocalVps.length > 1 ? this._state.spt.touchLocalVps : this._state.spt.changedTouchLocalVps;
			let epts = this._state.ept.touchLocalVps.length > 1 ? this._state.ept.touchLocalVps : this._state.ept.changedTouchLocalVps;

			let spt0 = spts[0].docPt[idx];
			let spt1 = spts[1].docPt[idx];
			let ept0 = epts[0].docPt[idx];
			let ept1 = epts[1].docPt[idx];
			let doScale = this._state.type == 4 || this._state.type == 6;
			let doRotate = this._state.type == 5 || this._state.type == 6;

			// 拡大率

			const sd = sonbp.util.c2d.getDistance(spt0, spt1);
			const ed = sonbp.util.c2d.getDistance(ept0, ept1);
			let scale = ed / sd

			// 回転角度

			const srad = sonbp.util.c2d.getRadian(spt0, spt1);
			const erad = sonbp.util.c2d.getRadian(ept0, ept1);
			let rad = erad - srad;

			this._vitem.save();
			this._vitem.init();

			if (doScale) {
				const pt0 = this._vitem.getPoints()[4];
				this._vitem.scale(scale, scale);
				const pt1 = this._vitem.getPoints()[4];
				this._vitem.move(pt0.x - pt1.x, pt0.y - pt1.y);
			}
			if (doRotate) {
				this._vitem.rotate(rad);
			}

			///this._state.ept = vp;
		}

		var result = new sonbp.type.listerResult();
		result.cursor = this.getEditCursor(this._state.handle);
		result.isPrevent = true;
		result.isDrawEditCanvas = true;
		result.isDrawPickCanvas = true;

		return result;
	}

	/**
	 * エンド内部処理
	 * @override
	 */
	protected onEnd(vp: sonbp.type.localViewPosition, hasShiftKey: boolean): sonbp.type.listerResult {
		if (!this._select.isSamePageIndex) return new sonbp.type.listerResult();
		if (!this._state.commitable) {
			let r = new sonbp.type.listerResult();
			r.isDrawFrontCanvas = true;
			return r;
		}

		// 編集確定処理

		var idx = this._v._dm.pageIdxs.indexOf(this._select.items[0]._apply_pageIdx);
		var spt = this._state.spt.docPt[idx];
		var ept = this._state.ept.docPt[idx];
		var that = this;

		if (this._state.type == 1) {

			// --------------------
			// 移動
			// --------------------

			// 移動モードで、何もマウスが動いていなければ伝搬する

			if (spt.equals(ept)) {
				return new sonbp.type.listerResult();
			}

			this._state.mvs.move(spt, ept, (itemRefs, dx, dy) => {
				return that._v._om.itemChange(itemRefs, function (itemRefs) {

					for (var i = 0; i < itemRefs.length; i++) {
						itemRefs[i].item.move(dx, dy);

						//はみ出しチェック
						itemMani.adjustPosition(that._ifdto, itemRefs[0].item, dx, dy);
					}

					return true;
				});
			});

		}
		else if (this._state.type == 2) {

			// --------------------
			// リサイズ
			// --------------------

			// shift操作 → アスペクト制御
			let aspect = this.isAvailableShift && hasShiftKey && sonbp.util.bp.checkPtidx(this._state.ptIdx, 1);
			let ptIdx = this._state.ptIdx;

			this._state.mvs.scale(ptIdx, spt, ept, aspect, (itemRefs, sx, sy, ptIdx, oppsitIdx) => {

				return that._v._om.itemChange(itemRefs, function (itemRefs) {

					if (itemRefs.length == 1) {

						var pts = itemRefs[0].item.points;
						itemRefs[0].item.scale(sx, sy);
						var pts2 = itemRefs[0].item.points;
						itemRefs[0].item.move(pts[oppsitIdx].x - pts2[oppsitIdx].x, pts[oppsitIdx].y - pts2[oppsitIdx].y);

						//はみ出しチェック
						itemMani.adjustPosition(that._ifdto, itemRefs[0].item);

					} else {

						//ポスカは複数選択無いので実装不要

					}

					return true;
				});
			});

		}
		else if (this._state.type == 3) {
			// --------------------
			// 回転
			// --------------------

			this._state.mvs.rotate(spt, ept, function (itemRefs, rad, cpt) {

				var deg = sonbp.util.c2d.deg(rad);

				return that._v._om.itemChange(itemRefs, function (itemRefs) {

					for (var i = 0; i < itemRefs.length; i++) {

						itemRefs[i].item.rotate(deg);

						var pt = itemRefs[i].item.points[4];
						var newpt = sonbp.util.c2d.getPointWithRotate(cpt, pt, rad);

						itemRefs[i].item.move(newpt.x - pt.x, newpt.y - pt.y);

						//はみ出しチェック
						itemMani.adjustPosition(that._ifdto, itemRefs[0].item);
					}

					return true;
				});
			});

		}
		else if (this._state.type == 4 || this._state.type == 5 || this._state.type == 6) {

			// --------------------
			// ２点 リサイズ／回転／リサイズ＆回転
			// --------------------

			let spts = this._state.spt.touchLocalVps.length > 1 ? this._state.spt.touchLocalVps : this._state.spt.changedTouchLocalVps;
			let epts = this._state.ept.touchLocalVps.length > 1 ? this._state.ept.touchLocalVps : this._state.ept.changedTouchLocalVps;

			this._state.mvs.scaleRotate(
				spts[0].docPt[idx], spts[1].docPt[idx],
				epts[0].docPt[idx], epts[1].docPt[idx],
				this._state.type == 4 || this._state.type == 6,
				this._state.type == 5 || this._state.type == 6,
				(itemRefs: sonbp.type.itemRefInfo[], doScale, doRotate, cpt, scale, rad) => {
					return this._v._om.itemChange(itemRefs, (itemRefs) => {

						if (doScale) {

							if (itemRefs.length == 1) {

								itemRefs[0].item.scale(scale, scale);
								let cpt1 = itemRefs[0].item.points[4];
								itemRefs[0].item.move(cpt.x - cpt1.x, cpt.y - cpt1.y);

							} else {

								const ptsm0 = sonbp.util.bp.getItemsPoints(itemRefs);
								const r0 = sonbp.util.c2d.getRectOfPoints(ptsm0.summary);

								for (let i = 0; i < itemRefs.length; i++) itemRefs[i].item.scale(scale, scale);

								const ptsm1 = sonbp.util.bp.getItemsPoints(itemRefs);
								const r1 = sonbp.util.c2d.getRectOfPoints(ptsm1.summary);
								const cpt1b = r1.getCenterPoint();
								const diffCpt = new sonbp.type.point(cpt1b.x - cpt.x, cpt1b.y - cpt.y);

								for (let i = 0; i < itemRefs.length; i++) {

									const rt = sonbp.util.c2d.getPosiRateInRect(ptsm0.parts[i][4], r0);
									const cpt1 = new sonbp.type.point(r1.x1 + r1.width * rt.x, r1.y1 + r1.height * rt.y);

									itemRefs[i].item.move(cpt1.x - ptsm1.parts[i][4].x - diffCpt.x, cpt1.y - ptsm1.parts[i][4].y - diffCpt.y);
								}
							}
						}
						if (doRotate) {

							const deg = sonbp.util.c2d.deg(rad);

							for (let i = 0; i < itemRefs.length; i++) {

								itemRefs[i].item.rotate(deg);

								let pt = itemRefs[i].item.points[4];
								let newpt = sonbp.util.c2d.getPointWithRotate(cpt, pt, rad);

								itemRefs[i].item.move(newpt.x - pt.x, newpt.y - pt.y);
							}
						}

						//はみ出しチェック
						itemMani.adjustPosition(that._ifdto, itemRefs[0].item);

						return true;
					});
				}
			);
		}

		this.init();
		this._vitem.initByItem();
		this._parent.acceptEditComplete();
		this.noticeChange();
	
		var result = new sonbp.type.listerResult();
		result.cursor = this.getEditCursor(this._state.handle);
		result.isReDraw = true;
		result.isPrevent = true;
		return result;
	}

	/**
	 * マウスアウト処理
	 * @override
	 */
	public evMouseout(e: MouseEvent, vp: sonbp.type.localViewPosition): sonbp.type.listerResult {
		if (!this._select.isSamePageIndex) return new sonbp.type.listerResult();

		let noedit = this.moveNotInEdit(e, vp);
		if (noedit) return noedit;

		console.debug("★★ドラッグ中のマウスアウト！");
		this.init();
		if (this._vitem != null) {
			this._vitem.initByItem();
			this._parent.acceptEditComplete();
		}

		let result = new sonbp.type.listerResult();
		result.isReDraw = true;
		result.isPrevent = true;

		return result;
	}

	// -----------------------
	// 描画機能 関数
	// -----------------------

	/**
	 * 非操作中の状態を描画する
	 * @override
	 */
	protected drawStaticState(co: sonbp.draw.editCanvasOperator): void {
		if (this._selectPointsCache == null) this._selectPointsCache = this._select.getPointsOfSummary().summary;

		//console.debug("poscaPickupEditor", "drawStaticState");

		co.ctx.save();

		this._v._dm.pageTransform(this._select.pageIndex, co.ctx);

		//選択候補描画
		this.gdrawEditCanvas(co);

		if (this._vitem != null) {

			let resizeNg = this._select.mode(sonbp.constant.editModeType.RESIZE_NG);
			let acceptNg = (this._select.items.length > 1 && this._select.mode(sonbp.constant.editModeType.ASPECT_NG));
			let rotateNg = this._select.mode(sonbp.constant.editModeType.ROTATION_NG);
			let moveNg = this._select.mode(sonbp.constant.editModeType.MOVE_NG);

			const d = 5;
			let out_points = sonbp.util.c2d.getOffsetPoints(this._selectPointsCache, d / this._v._dm.scaleRate);
			let base_points = sonbp.util.c2d.getOffsetPoints(this._selectPointsCache, (d / 2) / this._v._dm.scaleRate);

			//選択アイテム描画
			this.drawPickItem(co);

			// 矩形描画
			this.drawRect(co.ctx, this._selectPointsCache);

			// 移動ハンドル
			this.drawMovePoint(co.ctx, this._selectPointsCache, base_points, out_points, moveNg);

			// 回転ハンドル
			this.drawRotatePoint(co.ctx, this._selectPointsCache, base_points, out_points, rotateNg);

			// リサイズハンドル
			this.drawResizePoint(co.ctx, this._selectPointsCache, base_points, out_points, resizeNg, acceptNg);
		}

		co.ctx.restore();
	}

	/**
	 * 操作中の状態を描画する
	 * @override
	 */
	protected drawEditState(co: sonbp.draw.editCanvasOperator): void {

		//console.debug("poscaPickupEditor", "drawEditState");

		let points = this._vitem.getPoints();

		let resizeNg = this._select.mode(sonbp.constant.editModeType.RESIZE_NG);
		let acceptNg = (this._select.items.length > 1 && this._select.mode(sonbp.constant.editModeType.ASPECT_NG));
		let rotateNg = this._select.mode(sonbp.constant.editModeType.ROTATION_NG);
		let moveNg = this._select.mode(sonbp.constant.editModeType.MOVE_NG);

		const d = 5;
		let out_points = sonbp.util.c2d.getOffsetPoints(this._selectPointsCache, d / this._v._dm.scaleRate);
		let base_points = sonbp.util.c2d.getOffsetPoints(this._selectPointsCache, (d / 2) / this._v._dm.scaleRate);

		co.ctx.save();

		co.initialize();
		this._v._dm.pageTransform(this._select.pageIndex, co.ctx);

		//選択候補描画
		this.gdrawEditCanvas(co);

		//選択アイテム描画
		this.drawPickItem(co);

		// 矩形描画
		this.drawRect(co.ctx, points);

		// 移動ハンドル
		this.drawMovePoint(co.ctx, points, base_points, out_points, moveNg);

		// 回転ハンドル
		this.drawRotatePoint(co.ctx, points, base_points, out_points, rotateNg);

		// リサイズハンドル
		this.drawResizePoint(co.ctx, points, base_points, out_points, resizeNg, acceptNg);

		co.ctx.restore();
	}

	/**
	 * eidtCanvasへの描画
	 * @override
	 */
	public drawPickCanvas(co: sonbp.draw.editCanvasOperator): void {
		//nop.
	}

	/**
	 * pickLayerCanvasへの描画
	 */
	public abstract drawPickItem(co: sonbp.draw.canvasOperator): void;

	/**
	 * eidtCanvasへの描画
	 */
	protected abstract gdrawEditCanvas(co: sonbp.draw.canvasOperator): void;

	// -----------------------------------------------
	// Methods（内部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * 適用するスケールを演算する
	 */
	protected scaleSub(v: sonbp.type.point, pts: sonbp.type.point[], ptIdx: number): number[] {

		// ベクトルを変換
		var rad = sonbp.util.c2d.getRadian(pts[4], pts[5]);
		var vv = sonbp.util.c2d.getPointWithRotate(new sonbp.type.point(0, 0), v, -rad);

		// ベクトル調整
		if (ptIdx % 3 == 0) vv.x *= -1;
		else if (ptIdx % 3 == 1) vv.x = 1;
		if (ptIdx <= 2) vv.y *= -1;
		else if (3 <= ptIdx && ptIdx <= 5) vv.y = 1;

		// スケールを算定
		var w = sonbp.util.c2d.getDistance(pts[3], pts[5]);
		var h = sonbp.util.c2d.getDistance(pts[1], pts[7]);
		var sx = (w + vv.x) / w;
		var sy = (h + vv.y) / h;

		// アスペクト比固定
		if (sx > sy) sx = sy;
		else sy = sx;

		//拡縮制限チェック
		let s = {
			sx: sx,
			sy: sy
		};
		let vi = this._vitem;
		itemMani.chkScaleOver(this._ifdto, vi.item, vi.apply_matrix, vi.apply_points, s);
		sx = s.sx;
		sy = s.sy;

		return [sx, sy];
	}

	/**
	 * 適用するラジアンを演算する
	 */
	protected rotateSub(spt: sonbp.type.point, ept: sonbp.type.point, pts: sonbp.type.point[], rscore: number): number {

		var cpt = pts[4];
		var rad = sonbp.util.c2d.getRadian(cpt, ept) - sonbp.util.c2d.getRadian(cpt, spt);

		if (rscore != 0) {
			var deg = sonbp.util.c2d.deg(rad);
			rad = sonbp.util.c2d.rad(deg - deg % rscore);
		}

		return rad;
	}

}
